import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../slice/userSlice';
import { useDispatch } from 'react-redux';
import { IoPersonCircleSharp } from 'react-icons/io5';
import { MdDashboard, MdOutlineBusiness } from 'react-icons/md';
import { FaUsers, FaImage, FaCar, FaEdit, FaTools, FaStar, FaEnvelope, FaPhoneAlt, FaTimes, FaBars } from 'react-icons/fa';
import logo from '../asserts/logo.png';
import '../pages_premium.css';


const Layout = ({ children }) => {
  const [toggled, setToggle] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [propertiesOpen, setPropertiesOpen] = useState(false);
  const [carsOpen, setCarsOpen] = useState(false);
  const [hirematesOpen, setHirematesOpen] = useState(false);
  const [blogsOpen, setBlogsOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const currentUrl = location.pathname;
  const lastSegment = currentUrl.substring(currentUrl.lastIndexOf('/') + 1);

  useEffect(() => {
    setMobileOpen(false);
    if (currentUrl.startsWith('/properties') || currentUrl.includes('property-requests') || currentUrl.includes('inspections')) {
      setPropertiesOpen(true);
    }
    if (currentUrl.startsWith('/cars') || currentUrl.includes('car-bookings')) {
      setCarsOpen(true);
    }
    if (currentUrl.startsWith('/blogs') || currentUrl === '/blog') {
      setBlogsOpen(true);
    }
    if (currentUrl.includes('hiremate')) {
      setHirematesOpen(true);
    }
  }, [currentUrl]);

  // Logout handler
  const logoutHandler = async (e) => {
    e.preventDefault();
    try {
      dispatch(logout());
      navigate('/signin');
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div id="wrapper">
      {/* Mobile Sidebar Backdrop Overlay */}
      {mobileOpen && (
        <div
          className="sidebar-mobile-backdrop d-md-none"
          onClick={() => setMobileOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* Sidebar */}
      <ul
        className={`navbar-nav sidebar accordion shadow ${toggled ? 'toggled' : ''} ${mobileOpen ? 'mobile-open' : ''}`}
        id="accordionSidebar"
      >
        {/* Sidebar - Brand */}
        <div className="sidebar-brand-row">
          <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/dashboard">
            <div className="sidebar-logo-wrap">
              <img src={logo} alt="Logo" className="sidebar-logo-img" />
            </div>
          </Link>
          <button
            type="button"
            className="sidebar-mobile-close-btn d-md-none"
            onClick={() => setMobileOpen(false)}
            aria-label="Close sidebar"
          >
            <FaTimes size={16} />
          </button>
        </div>

        {/* Dashboard */}
        <li className={`nav-item mt-2 ${lastSegment === 'dashboard' ? 'active' : ''}`}>
          <Link className="nav-link px-3 py-2.5 d-flex align-items-center" to="/dashboard">
            <MdDashboard className="mr-2.5" size={20} />
            <span style={{ fontSize: "15px" }} className="font-weight-bold">Dashboard</span>
          </Link>
        </li>

        {/* Messages */}
        <li className={`nav-item ${lastSegment === 'messages' ? 'active' : ''}`}>
          <Link className="nav-link px-3 py-2.5 d-flex align-items-center" to="/messages">
            <FaEnvelope className="mr-2.5" size={18} />
            <span style={{ fontSize: "15px" }} className="font-weight-bold">Messages</span>
          </Link>
        </li>

        {/* Users */}
        <li className={`nav-item ${lastSegment === 'users' ? 'active' : ''}`}>
          <Link className="nav-link px-3 py-2.5 d-flex align-items-center" to="/users">
            <FaUsers className="mr-2.5" size={19} />
            <span style={{ fontSize: "15px" }} className="font-weight-bold">Users</span>
          </Link>
        </li>

        {/* Property Management Dropdown */}
        <li className={`nav-item ${(currentUrl.startsWith('/properties') || currentUrl.includes('property-requests') || currentUrl.includes('inspections')) ? 'active' : ''}`}>
          <a
            className={`nav-link px-3 py-2.5 d-flex align-items-center ${propertiesOpen ? '' : 'collapsed'}`}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setPropertiesOpen(!propertiesOpen);
            }}
          >
            <MdOutlineBusiness className="mr-2.5" size={20} />
            <span style={{ fontSize: "15px" }} className="font-weight-bold">Property Management</span>
          </a>
          <div className={`collapse ${propertiesOpen ? 'show' : ''}`} style={{ transition: "all 0.3s ease" }}>
            <div className="bg-white py-2 collapse-inner rounded" style={{ margin: "0 0.5rem" }}>
              <Link className="d-block px-3 py-2 text-dark text-decoration-none font-weight-bold" style={{ fontSize: "14px" }} to="/properties">Property List</Link>
              <Link className="d-block px-3 py-2 text-dark text-decoration-none font-weight-bold" style={{ fontSize: "14px" }} to="/property-requests">Property Requests</Link>
              <Link className="d-block px-3 py-2 text-dark text-decoration-none font-weight-bold" style={{ fontSize: "14px" }} to="/inspections">Inspections</Link>
              <Link className="d-block px-3 py-2 text-dark text-decoration-none font-weight-bold" style={{ fontSize: "14px" }} to="/properties/add">Add Property</Link>
            </div>
          </div>
        </li>

        {/* Car Management Dropdown */}
        <li className={`nav-item ${(currentUrl.startsWith('/cars') || currentUrl.includes('car-bookings')) ? 'active' : ''}`}>
          <a
            className={`nav-link px-3 py-2.5 d-flex align-items-center ${carsOpen ? '' : 'collapsed'}`}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setCarsOpen(!carsOpen);
            }}
          >
            <FaCar className="mr-2.5" size={18} />
            <span style={{ fontSize: "15px" }} className="font-weight-bold">Car Management</span>
          </a>
          <div className={`collapse ${carsOpen ? 'show' : ''}`} style={{ transition: "all 0.3s ease" }}>
            <div className="bg-white py-2 collapse-inner rounded" style={{ margin: "0 0.5rem" }}>
              <Link className="d-block px-3 py-2 text-dark text-decoration-none font-weight-bold" style={{ fontSize: "14px" }} to="/cars">Car List</Link>
              <Link className="d-block px-3 py-2 text-dark text-decoration-none font-weight-bold" style={{ fontSize: "14px" }} to="/car-bookings">Car Bookings / Inspections</Link>
              <Link className="d-block px-3 py-2 text-dark text-decoration-none font-weight-bold" style={{ fontSize: "14px" }} to="/driver-verifications">Driver Verifications</Link>
            </div>
          </div>
        </li>

        {/* Hiremate Management Dropdown */}
        <li className={`nav-item ${lastSegment === 'hiremates' || lastSegment === 'hiremate-jobs' || lastSegment === 'hiremate-tasks' ? 'active' : ''}`}>
          <a
            className={`nav-link px-3 py-2.5 d-flex align-items-center ${hirematesOpen ? '' : 'collapsed'}`}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setHirematesOpen(!hirematesOpen);
            }}
          >
            <FaTools className="mr-2.5" size={18} />
            <span style={{ fontSize: "15px" }} className="font-weight-bold">Hiremate Management</span>
          </a>
          <div className={`collapse ${hirematesOpen ? 'show' : ''}`} style={{ transition: "all 0.3s ease" }}>
            <div className="bg-white py-2 collapse-inner rounded" style={{ margin: "0 0.5rem" }}>
              <Link className="d-block px-3 py-2 text-dark text-decoration-none font-weight-bold" style={{ fontSize: "14px" }} to="/hiremates">Hiremate List</Link>
              <Link className="d-block px-3 py-2 text-dark text-decoration-none font-weight-bold" style={{ fontSize: "14px" }} to="/hiremate-jobs">Job List</Link>
              <Link className="d-block px-3 py-2 text-dark text-decoration-none font-weight-bold" style={{ fontSize: "14px" }} to="/hiremate-tasks">Task List</Link>
            </div>
          </div>
        </li>

        {/* Flatmates */}
        <li className={`nav-item ${lastSegment === 'flatmates' ? 'active' : ''}`}>
          <Link className="nav-link px-3 py-2.5 d-flex align-items-center" to="/flatmates">
            <FaUsers className="mr-2.5" size={18} />
            <span style={{ fontSize: "15px" }} className="font-weight-bold">Roommates</span>
          </Link>
        </li>

        {/* Banners */}
        <li className={`nav-item ${lastSegment === 'banners' ? 'active' : ''}`}>
          <Link className="nav-link px-3 py-2.5 d-flex align-items-center" to="/banners">
            <FaImage className="mr-2.5" size={18} />
            <span style={{ fontSize: "15px" }} className="font-weight-bold">Banners</span>
          </Link>
        </li>

        {/* Blogs Dropdown */}
        <li className={`nav-item ${lastSegment.startsWith('blogs') || lastSegment === 'blog' ? 'active' : ''}`}>
          <a
            className={`nav-link px-3 py-2.5 d-flex align-items-center ${blogsOpen ? '' : 'collapsed'}`}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setBlogsOpen(!blogsOpen);
            }}
          >
            <FaEdit className="mr-2.5" size={18} />
            <span style={{ fontSize: "15px" }} className="font-weight-bold">Blogs</span>
          </a>
          <div className={`collapse ${blogsOpen ? 'show' : ''}`} style={{ transition: "all 0.3s ease" }}>
            <div className="bg-white py-2 collapse-inner rounded" style={{ margin: "0 0.5rem" }}>
              <Link className="d-block px-3 py-2 text-dark text-decoration-none font-weight-bold" style={{ fontSize: "14px" }} to="/blogs/add">Add Blog</Link>
              <Link className="d-block px-3 py-2 text-dark text-decoration-none font-weight-bold" style={{ fontSize: "14px" }} to="/blogs">Blog List</Link>
            </div>
          </div>
        </li>

        {/* Testimonials */}
        <li className={`nav-item ${lastSegment === 'testimonials' ? 'active' : ''}`}>
          <Link className="nav-link px-3 py-2.5 d-flex align-items-center" to="/testimonials">
            <FaStar className="mr-2.5" size={18} />
            <span style={{ fontSize: "15px" }} className="font-weight-bold">Testimonials</span>
          </Link>
        </li>

        {/* Contact Us Enquiries */}
        <li className={`nav-item ${lastSegment === 'contact-enquiries' ? 'active' : ''}`}>
          <Link className="nav-link px-3 py-2.5 d-flex align-items-center" to="/contact-enquiries">
            <FaPhoneAlt className="mr-2.5" size={18} />
            <span style={{ fontSize: "15px" }} className="font-weight-bold">Contact Us Enquiries</span>
          </Link>
        </li>

        {/* Divider */}
        <hr className="sidebar-divider d-none d-md-block mt-4" style={{ borderColor: 'rgba(255,255,255,0.1)' }} />

        {/* Sidebar Toggler */}
        <div className="text-center d-none d-md-inline">
          <button
            className="rounded-circle border-0"
            id="sidebarToggle"
            onClick={() => setToggle(!toggled)}
          ></button>
        </div>
      </ul>
      {/* End of Sidebar */}

      {/* Content Wrapper */}
      <div id="content-wrapper" className="d-flex flex-column">
        {/* Main Content */}
        <div id="content">
          {/* Premium Topbar */}
          <nav className="navbar navbar-expand navbar-light topbar-premium mb-4 static-top shadow">
            <div className="d-flex align-items-center d-md-none mobile-topbar-brand-group">
              <button
                id="sidebarToggleTop"
                type="button"
                className="mobile-menu-toggle-btn"
                onClick={() => setMobileOpen(!mobileOpen)}
                aria-label="Toggle navigation menu"
              >
                <FaBars size={18} />
              </button>
              <Link to="/dashboard" className="mobile-topbar-logo-link d-md-none">
                <img src={logo} alt="Students Union" className="mobile-topbar-logo" />
              </Link>
            </div>

            {/* Topbar Navbar */}
            <ul className="navbar-nav ml-auto">
              {/* Nav Item - User Information */}
              <li className="nav-item dropdown no-arrow">
                <Link
                  className="nav-link dropdown-toggle"
                  to="#"
                  id="userDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <div className="topbar-user-wrap">
                    <span className="topbar-user-name d-none d-lg-inline">Admin User</span>
                    <div className="topbar-user-icon">
                      <IoPersonCircleSharp size={28} />
                    </div>
                  </div>
                </Link>
                {/* Dropdown - User Information */}
                <div
                  className="dropdown-menu dropdown-menu-right dropdown-menu-premium animated--grow-in"
                  aria-labelledby="userDropdown"
                >
                  <Link className="dropdown-item dropdown-item-premium" to="#" onClick={logoutHandler}>
                    <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2"></i>
                    Logout
                  </Link>
                </div>
              </li>
            </ul>
          </nav>
          {/* End of Premium Topbar */}

          {/* Begin Page Content */}
          <div className="container-fluid" style={{ minHeight: "80vh" }}>
            {children}
          </div>
          {/* End of Page Content */}
        </div>
        {/* End of Main Content */}

        {/* Footer */}
        <footer className="sticky-footer bg-white">
          <div className="container my-auto">
            <div className="copyright text-center my-auto">
              <span>Copyright &copy; Students Union AU 2026</span>
            </div>
          </div>
        </footer>
        {/* End of Footer */}
      </div>
      {/* End of Content Wrapper */}
    </div>
  );
};

export default Layout;
